import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: Montserrat;
`;

export const Title = styled.h4`
  font-weight: 600;
  font-size: 20px;
  margin: 0 0 16px 0;
  color: #25282b;
  text-align: left;
`;

export const ModalButton = styled.button`
  background: #007eff;
  box-shadow: 0px 8px 16px rgba(0, 126, 255, 0.16);
  border-radius: 8px;
  padding: 11px 24px;
  width: min-content;
  align-self: flex-end;
  &:hover {
    background: #007eff;
  }
`;
export const Paragraph = styled.p`
  margin: 0 0 16px;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  text-align: left;
`;
